import { useEffect, useRef } from 'react';

import { useFetchServiceFeeCalculation } from '../api/actions/useFetchServiceFeeCalculation';

export const useMaybeFetchServiceFee = ({
  isServiceFeeEnabled,
  isServiceFeeSelectedCoveredDefault,
  offeringAmount,
  setTotalAmountToPay,
  userCoversServiceFee,
}) => {
  const { query, loading, abort } = useFetchServiceFeeCalculation(offeringAmount);

  const firstRender = useRef(true);

  useEffect(() => {
    if (!userCoversServiceFee && !Number.isNaN(offeringAmount)) {
      setTotalAmountToPay(offeringAmount);
    }
  }, [userCoversServiceFee, offeringAmount]);

  useEffect(() => {
    if (
      !userCoversServiceFee ||
      !isServiceFeeEnabled ||
      (firstRender.current && !isServiceFeeSelectedCoveredDefault)
    ) {
      return () => {};
    }

    const run = async () => {
      if (offeringAmount === null) {
        return;
      }

      const { payload } = await query();

      if (payload) {
        setTotalAmountToPay(payload.totalAmount);
      }
    };

    run();

    return () => abort();
  }, [userCoversServiceFee, offeringAmount]);

  useEffect(() => {
    firstRender.current = false;
  }, []);

  return {
    loading,
  };
};
